import { defineMessages } from "@/i18n";
import en from "./en";

export const settingsSkillsMessages = defineMessages("settings-skills", en);
